function Accessibility(){
    jQuery(function(){
        jQuery(".navbar a").attr("tabindex",0);
    })
}

export default Accessibility;